<template>
    <div id="index" style="background-color: #F5F5F5;position: relative;">
        <Header></Header>
        <div id="firstSection" style="min-height: 850px;">
            <div id="banner" data-app-id="full-banner">
                <div class="item-drag-wrap text-module-container ui-resizable"
                    style="position: absolute;top:106px;left:50%;margin-left:-291.5px;">
                    <div class="text-module item-content" dblclickedit="true">
                        <div class="item-main"></div>
                    </div>
                </div>

                <div class="page-banner-style22 pageBannerTwentyTwo0" style="background: #ffffff" data-index="0"
                    data-pagebannertwentytwo="0">
                    <div class="banner-slide-box " style="color: #333333">
                        <div class="device">
                            <!-- <span class="arrow-left "></span>
                            <span class="arrow-right "></span> -->
                            <div class="next titlefsnull titledfw"></div>
                        </div>
                        <div class="swiper-container full-banner">
                            <div class="swiper-wrapper" style=" height: 800px; position: relative;">
                                <el-carousel :interval="30000" arrow="always" height="800px" v-show="videoShow">
                                    <el-carousel-item v-for="(item, index) in bannerImg" :key="index" loop>
                                        <h3 class="medium" style="height:100%">
                                            <img class="img" :src="item.picUrl" alt="" @click="imgOpenLink(item)"
                                                style="height: 100%;width:100%;background-size: 100% 100%;cursor: pointer;">
                                        </h3>
                                    </el-carousel-item>
                                </el-carousel>
                                <video v-if="!videoShow" ref="videoPlayer" width="100%" height="100%" class="startVideo"
                                    controls :autoplay="autoplay" muted object-fit="cover" loop @play="clickVideo">
                                    <source :src="videoSource" type="video/mp4" />
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-wrap">
                <div id="grid1" class="grid-stack grid-stack-instance-2210" style="opacity: 1; height: 770px;">
                    <div data-app-id="layout_0" class="grid-stack-item base-container layout-drag"
                        style="width: 100%;height: 30px;">
                        <div class="grid-stack-item-content">
                            <div class="custom-draggable-handle"></div>
                            <div class="layout-content layout-content1_1 no-margin custom-draggable-handle ui-resizable"
                                style="left: 0px; width: 1175.3px;"></div>
                        </div>
                    </div>
                    <div data-app-id="33996" class="grid-stack-item base-container"
                        style="width: 21%;left: 3%;height: 140px;top: 30px;position: absolute;">
                        <div class="grid-stack-item-content">
                            <div class="item-drag-wrap text-module-container ui-resizable"
                                style="position: absolute; left: 5%; left: 20px; width: 176px;">
                                <div class="text-module item-content pointer" dblclickedit="true"
                                    data-url="https://720yun.com/t/5e0jz7waea7?scene_id=59843481" data-target="_blank">
                                    <div class="item-main" style="position: relative;">
                                        <p>
                                            <span style="color:#000000">
                                                <strong>
                                                    <span style="font-size:18px">
                                                        <span
                                                            style="cursor: pointer;color:#fff;font-size: 25px;margin-bottom: 30px;"
                                                            @click="VRlink">VR图书馆</span></span>
                                                </strong>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div><!--文本列表6-->
                            <div class="text-list-box new-eng-text-style9 style-66318367-40a3-49a7-84ed-416131977396"
                                id="text-style-8-66318367-40a3-49a7-84ed-416131977396"
                                style="background:rgba(255, 255, 255, 0);color: rgba(255, 255, 255, 1);">
                                <div class="text-list-wrap clear">
                                    <!--tab 切换-->
                                    <div class="eng-null-data engine-no-data" style="display: none">
                                        <img src="/engine2/assets/images/style/engine/img_null_data.png" alt="">
                                        <p class="tip">暂无数据</p>
                                    </div>
                                    <div class="scrollTextBox engine-show-data">
                                        <!-- <ul class="eng-tabs-info clear">
                                            <li class="engine_text_jump clear"
                                                style="cursor: default; width: calc(100% / 2)!important;">
                                                <div class="title titlefsnull titledfw titledff0">当前在馆人数</div>
                                                <div class="num">998</div>
                                            </li>
                                            <li class="engine_text_jump clear"
                                                style="cursor: default; width: calc(100% / 2)!important;">
                                                <div class="title titlefsnull titledfw titledff0">当前剩余座位</div>
                                                <div class="num">2893</div>
                                            </li>
                                        </ul> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-app-id="10371" class="grid-stack-item-base-container"
                        style="width: 90%;height: 392px;top: 170px;position: absolute;left: 3%;">
                        <div class="grid-stack-item-content">
                            <div class="eng-search-style11 active eng-commoncss-search"
                                style="background: rgba(0, 0, 0,0.3)">
                                <div style="color:#333333">
                                    <div class="top-item clear">
                                        <div class="down-box fl">
                                            <!-- <i class="icon-search"></i> -->
                                            <span class="tip">{{ typename }}</span>
                                            <span class="icon-down fr"></span>
                                        </div>
                                        <div class="nav-list fl clear">
                                            <div v-for="(item, index) in collectionerjiArr" :key="index">
                                                <span class="item overHidden1 " :class="{ 'current': tabs == index }"
                                                    @click="querysanjiCondition(item, index)">{{ item.name }}</span>
                                                <i class="icon-unfold el-icon-bottom" @click="expand"
                                                    v-if="!collapse"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <core-collapse-transition>
                                        <div class="down-info clear" v-show="collapse"
                                            style="background: rgba(0, 0, 0,0.91)">
                                            <ul class="left-tab fl" style="height:337px;overflow:hidden;">
                                                <li data-id="15889" v-for="(item, index) in collectionArr" :key="index">
                                                    <span style="display: inline-block;width: 100%;"
                                                        :class="{ 'bgTheme': tab == index }"
                                                        @click="queryerjiCondition(item, index)">{{ item.name }}</span>
                                                </li>
                                            </ul>
                                            <div class="fl tab-right-content">
                                                <div class="tab-content  bacList"
                                                    style="background-color: rgb(176, 37, 42) ">
                                                    <div class="search-box" style="padding-right: 66px;">
                                                        <el-input v-model="searchInput" class="ipt"
                                                            @keyup.native.enter="searchLink"
                                                            placeholder="温馨提示：直接点击搜索，进入检索界面">
                                                        </el-input>
                                                        <div class="btns"><button type="button" class="btn-search "
                                                                @click="searchLink">搜索</button></div>
                                                    </div>
                                                    <div class="search-tip overHidden3">
                                                        <!-- <span v-for="(item,index) in collectionerjiArr">
                                                            <span v-show="{contentShow : item.contentShow == true  }">{{ item.content }}</span>
                                                        </span> -->
                                                        <span
                                                            style="text-indent: 2em;display:inline-block">{{ resourcesErjiName }}</span>
                                                    </div>
                                                    <div class="radio-list" v-show="showType">
                                                        <a style="display: inline-block;">
                                                            <el-radio-group v-model="radio" @change="changeMax">
                                                                <el-radio v-model="addCagLabel"
                                                                    v-for="item in collectionsanjiArr" :key="item.value"
                                                                    :label="item.name" :value="item.value">
                                                                </el-radio>
                                                            </el-radio-group>
                                                        </a>
                                                    </div>
                                                    <div class="href-list" v-show="!showType">
                                                        <a v-for="(item, index) in collectionsanjiArr" :key="index">
                                                            <i class="ui-circle"></i>
                                                            <span @click="goCondition(item)">{{ item.name }}</span>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="icon-packUP">
                                                    <i class="icon-unfold icon-packUP el-icon-bottom" @click="fold"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </core-collapse-transition>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-app-id="layout_1" class="grid-stack-item base-container layout-drag"
                        style="width: 100%;height: 30px;top: 590px;position: absolute;">
                        <div class="grid-stack-item-content">
                            <div class="custom-draggable-handle"></div>
                            <div class="layout-content layout-content1_1 no-margin custom-draggable-handle ui-resizable ui-draggable-handle"
                                style="left: 0px; width: 1174.66px;"></div>
                        </div>
                    </div>
                    <div data-app-id="11545" class="grid-stack-item base-container"
                        style="width: 100%;height: 110px;top: 620px;position: absolute;">
                        <div class="grid-stack-item-content">
                            <div class="eng-icons-style11" style="background: rgba(0, 0, 0, 0.27);height: 100%;">
                                <div class="icons-list clear"
                                    style="color: rgba(255, 255, 255, 1);cursor: pointer;padding-top: 16px;">
                                    <!--设置文字颜色-->
                                    <a class="items" v-for="(item, index) in kuaijieData" :key="index">
                                        <div class="icon-box js-crop-img" @click="goShortcut(item, index)">
                                            <div class="jqthumb"
                                                style="width: 100%;  position: relative; overflow: hidden;">
                                                <div style="text-align: center;width: 100%; ">
                                                    <img :src="item.picUrl" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="item-name titlefsnull titledfw" @click="goShortcut(item, index)">
                                            {{ item.name }}
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="aid-group-wrap">
                <div id="sidGroups">
                    <!-- 左侧菜单 -->
                    <div id="quickEntry" style="opacity: 1;" class="screen-left">
                        <div class="custom-text-style3 shortcut-position-1" data-shortcutposition="1"
                            style="color: #ffffff;">
                            <div class="list clear">
                                <a class="list-item  " target="_self" href="javascript:;"
                                    v-for="(item, index) in leftNavImg" :key="index">
                                    <div class="box bg-theme" @mouseenter="move(item, index)"
                                        @mouseleave="leave(item, index)" @click="imgOpenLink(item)">
                                        <!-- <i class="el-icon-chat-dot-round"></i> -->
                                        <span class="txt">{{ item.title }}</span>

                                        <div class="big-box" style="left: 140px;"
                                            v-show='item.picUrl != "" && leftIndex == index'>
                                            <img :src="item.picUrl" alt="">
                                        </div>
                                    </div>
                                </a>
                                <p class="goTop" @click="goTop">
                                    <span>TOP</span>
                                    <i class="el-icon-caret-top"></i>
                                </p>
                            </div>
                        </div>
                    </div>
                    <!-- 右侧导航 -->
                    <div id="anchorsNav" class=""><!---->
                        <ul class="anchors-nav common-right-nav2">
                            <li>
                                <a @click="openLink()">
                                    <img style="cursor: pointer;" src="../assets/images/phone.png"
                                        class="pagination-item-icon">
                                    <p class="anchors-name overHidden1 ">联系我们</p>
                                </a>
                            </li>
                            <li v-for="(e, index) in dataInfo">
                                <a :class="{ 'active': active == index }" @click="clickNav(index)">
                                    <img :src="e.icon" class="pagination-item-icon">
                                    <p class="anchors-name overHidden1 ">{{ e.title }}</p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="aid-groups">
                    <div class="grid-wrap">
                        <div id="grid2" data-nav-id="2" class="grid-stack grid-stack-instance-2210"
                            data-gs-current-height="97" style=" opacity: 1;">
                            <div data-app-id="layout_2" class="grid-stack-item base-container layout-drag"
                                style="height: 350px;background-color: #fff;margin-bottom: 20px;">
                                <div class="grid-stack-item-content" style="overflow: hidden;">
                                    <div class="custom-draggable-handle"></div>
                                    <div class="layout-content custom-draggable-handle ui-resizable ui-draggable-handle"
                                        data-app-id="14188" style="left: 0px; width: 530px;height: 100%;">
                                        <div class="text-list-box new-eng-textlist-style2 style-984e3afe-ca9c-444c-b5cf-908fe66c0213"
                                            id="text-style-2-984e3afe-ca9c-444c-b5cf-908fe66c0213"
                                            style="background: #fff0">
                                            <div class="item-engine-title clear txt-l">
                                                <!--居左：txt-l；居中：txt-c；居右：txt-l；-->
                                                <!--        <span class="title-icon fl bg-theme" style="background: #3D82F2;"></span>-->
                                                <span class="title-t"><span class="title-icon bg-theme"
                                                        style="background: #3D82F2;"></span>新闻通知</span>
                                                <a target="_blank" data-href="/engine2/m/4CE5523FB032D084?p=14305"
                                                    id="more-984e3afe-ca9c-444c-b5cf-908fe66c0213" class="more fr">
                                                    <span @click="goMoreList" style="cursor: pointer;">
                                                        更多 >
                                                    </span>

                                                    <i class="icon-up"></i>
                                                </a>
                                            </div>
                                            <div class="text-list-wrap">
                                                <!--tab 切换-->
                                                <div class="eng-null-data engine-no-data" style="display: none">
                                                    <img src="/engine2/assets/images/style/engine/img_null_data.png"
                                                        alt="">
                                                    <p class="tip">暂无数据</p>
                                                </div>
                                                <div class="scrollTextBox engine-show-data" style="width: 100%;">
                                                    <ul class="info-list show" style="height: 310px;overflow: hidden;">
                                                        <li class="engine_text_jump"
                                                            style="cursor: pointer;display:flex"
                                                            v-for="item in tableData">
                                                            <span
                                                                style="display: inline-block;width: 90px;margin-right: 10px"
                                                                @click="goDatial(item)">{{ item.createTime }}</span>
                                                            <i
                                                                style="display:inline-block;height: 25px;width:1px;border-right: 1px solid #ccc;margin-top:15px"></i>
                                                            <span
                                                                :class="item.xwtype == 1 ? 'bacColor' : (item.xwtype == 2?'bacColor2':'bacColor3')"
                                                                style="padding: 10px">{{ item.xwtypename }}</span>
                                                            <a class="txt  titlefs15 titledfw titledff0"
                                                                href="javascript:;"
                                                                @click="goDatial(item)">{{ item.titile }}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="layout-content custom-draggable-handle ui-resizable"
                                        data-app-id="949527"
                                        style="left: 560px; width: 650px;position: absolute;top: 15px;">
                                        <div class="text-list-box new-eng-textlist-style2 style-ef688e23-5556-43b2-bf87-7d121710b98c"
                                            id="text-style-2-ef688e23-5556-43b2-bf87-7d121710b98c"
                                            style="background: rgba(61, 130, 242, 0)">
                                            <div class="item-engine-title clear txt-l">
                                                <span class="title-t">
                                                    <span class="title-icon bg-theme" style="background: #3D82F2;">
                                                    </span>
                                                    <span>活动日历</span>
                                                </span>
                                                <a target="_blank" data-href="/engine2/m/D1243C171D28EA6B?p=14305"
                                                    id="more-ef688e23-5556-43b2-bf87-7d121710b98c" class="more fr">
                                                    <span style="cursor: pointer;" @click="goHuoDong">
                                                        更多 &gt;
                                                    </span>

                                                    <i class="icon-up"></i>
                                                </a>
                                            </div>
                                            <div class="searchTime">
                                                <!-- <div class="leftButton el-icon-arrow-left">
                                                </div>
                                                <ul>
                                                    <li v-for="item in dateArray">{{ (item.slice(5, 9)).replace('/', '-') }}
                                                    </li>
                                                </ul>
                                                <div class="rightButton el-icon-arrow-right">
                                                </div> -->
                                                <calendar @date-selected="gotime"></calendar>
                                            </div>
                                            <div class="text-list-wrap-img">
                                                <!--tab 切换-->
                                                <div v-show="nullShow">
                                                    <p style="font-size: 25px;text-align: center;margin-top: 100px;">
                                                        暂无数据
                                                    </p>
                                                </div>
                                                <div class="imgUrl" v-show="!nullShow">
                                                    <div v-for="item in calendarActiveData" style="margin-right: 15px;">
                                                        <img :src="item.picUrl" alt="" @click="goDatial(item)">
                                                        <p @click="goDatial(item)">{{ item.titile }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div data-app-id="16988" class="grid-stack-item base-container">
                                <div class="grid-stack-item-content">
                                    <div oncontextmenu="return false" class="eng-icons-style4"
                                        id="eng-icons-style4-c643abaf-f127-4b74-a18a-2a8e4395c0b0"
                                        style="background: rgba(255, 255, 255, 1)">
                                        <div class="item-engine-title clear txt-l">
                                            <span class="title-t"><span class="title-icon bg-theme"
                                                    style="background: #3D82F2;"></span><span><span
                                                        style="color: #000000;">读者服务</span></span></span>
                                        </div>

                                        <div class="icons-list clear" style="color: rgba(48, 48, 48, 1)">
                                            <a class="items txt-hover-theme" v-for="(item, index) in readerImg"
                                                :key="index">
                                                <div class="icon-box" @click="goDatialList(item, index)">
                                                    <img :src="item.picUrl">
                                                </div>
                                                <div class="item-name titlefs15 titlefw">{{ item.name }}</div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                style="min-height: 300px;max-height:400px; height: 100%;clear:both;display:flex;overflow: hidden;}">
                                <div data-app-id="19944" class="grid-stack-item base-container  "
                                    style="width: 20%;top: 400px;">
                                    <div class="grid-stack-item-content">
                                        <div class="item-drag-wrap img-module-container ui-resizable"
                                            style="left: 165px; top: 0px; width: 95.0119px; height: 10px; margin-left: 0px; position: absolute;">
                                            <div class="img-module item-content">
                                                <div class="img-clip"
                                                    style="background-image: url(&quot;/upload/portal/2020-10/20201012150202151E.png&quot;);">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="text-list-box new-eng-textlist-style30 style-2a4b8bd6-e0c6-4fa7-8960-e7f34a56a3ee"
                                            id="text-style-29-2a4b8bd6-e0c6-4fa7-8960-e7f34a56a3ee">
                                            <div class="item-engine-title clear txt-l">
                                                <span class="title-t"><span class="title-icon bg-theme"
                                                        style="background: #3D82F2;"></span><span><span
                                                            style="color: #fff;">馆藏资源</span></span></span>
                                                <a target="_blank" class="more fr" style="color: #fff;cursor: pointer;"
                                                    @click="clickGczyMore">
                                                    <span>
                                                        更多 >
                                                    </span>
                                                    <i class="icon-up"></i>
                                                </a>
                                            </div>

                                            <div class="clear">
                                                <div class="textlist-info">
                                                </div>
                                                <div class="eng-null-data engine-no-data" style="display: none">
                                                    <img src="/engine2/assets/images/style/engine/img_null_data.png"
                                                        alt="">
                                                    <p class="tip">暂无数据</p>
                                                </div>
                                                <div class="scrollTextBox engine-show-data">
                                                    <ul class="eng-tabs-info clear"
                                                        style="max-height: 280px;box-sizing: border-box;">
                                                        <li class="txt-hover-theme overHidden1 engine_text_jump"
                                                            v-for="(item, index) in resourcesArr">
                                                            <!--背景可换-->
                                                            <span class="index">{{ index + 1 }}</span>
                                                            <span class="txt titlefs15 titlefw"
                                                                @click="goLink(item)">{{ item.name }}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div data-app-id="36179" class="grid-stack-item base-container "
                                    style="width: 80%;top: 400px;left: 23%;">
                                    <div class="grid-stack-item-content">
                                        <div class="text-list-box new-eng-textlist-style38 style-75a06642-6559-443b-81b2-89487a14aed3 bg-theme"
                                            style="overflow: hidden;min-height: 180px">
                                            <div class="item-engine-title clear txt-l">
                                                <div class="bg-theme eng-title fl">数据库 <i
                                                        class="ui-triangle txt-theme"></i>
                                                </div>
                                                <a style="cursor: pointer;" class="more fr" @click="clickShujukuMore">
                                                    <span>
                                                        更多 >
                                                    </span>

                                                    <i class="icon-up"></i>
                                                </a>
                                                <div class="bg-theme-rgba bg-theme"></div>
                                            </div>
                                            <div>
                                                <div class="textlist-info" style="margin-bottom: 20px;">
                                                    <div class="eng-tabs show mh-eng-tabs-set mh-eng-tabs-style4">
                                                        <span v-for="(item, index) in oneDatabaseArr" :key="index">
                                                            <span class="type" :class="{ currents: txt == index }"
                                                                @click="queryTwoDatabase(item, index)">{{ item.name }}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="eng-null-data engine-no-data" style="display: none">
                                                    <img src="/engine2/assets/images/style/engine/img_null_data.png"
                                                        alt="">
                                                    <p class="tip">暂无数据</p>
                                                </div>

                                                <div style="max-height: 240px;height: 240px;overflow: hidden;">
                                                    <div class="scrollTextBox " style="height: 100%;padding-left:10px;">
                                                        <div class="eng-tabs-info clear"
                                                            style="float: left;margin-bottom: 10px;width: 146px"
                                                            v-for="(item, index) in twoDatabaseArr" :key="index">
                                                            <img :src="item.picUrl" alt=""
                                                                style="width: 100%;height:50px;cursor:pointer"
                                                                @click="goDatabase(item)">
                                                            <!-- <a class=""
                                                                style="width: 160px;line-height: 30px;float: left;color:#fff;overflow: hidden;"
                                                                @click="goDatabase(item)">{{ item.name }}</a> -->
                                                        </div>
                                                        <!-- <div class="eng-tabs-info clear"
                                                            style="width:150px;height:40px;box-sizing: border-box;float:left;margin-bottom: 20px;"
                                                            v-for="(item, index) in twoDatabaseArr" :key="index">
                                                            <img :src="item.picUrl" alt=""
                                                                style="width: 40px;height:40px;cursor:pointer;float: left;"
                                                                @click="goDatabase(item)">
                                                            <a class=""
                                                                style="display:block;width:90px;height: 40px;line-height: 40px;float: left;color:#fff;overflow: hidden;padding-left: 5px;"
                                                                @click="goDatabase(item)">{{ item.name }}</a>
                                                        </div> -->
                                                    </div>
                                                </div>
                                                <div class="clear"> </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div data-app-id="16988" class="grid-stack-item base-container grid-wrap"
                                style="margin-top: 20px;">
                                <div class="grid-stack-item-content">
                                    <div class="eng-icons-style4"
                                        id="eng-icons-style4-c643abaf-f127-4b74-a18a-2a8e4395c0b0"
                                        style="background: rgba(255, 255, 255, 1)">
                                        <div class="item-engine-title clear txt-l">
                                            <span class="title-t"><span class="title-icon bg-theme"
                                                    style="background: #3D82F2;"></span><span><span
                                                        style="color: #000000;">教学研究</span></span></span>
                                        </div>
                                        <div class="icons-list clear" style="color: rgba(48, 48, 48, 1)">
                                            <a class="items txt-hover-theme" style="width: 150px;"
                                                v-for="(item, index) in scientificImg" :key="index">
                                                <div class="icon-box" @click="goScientific(item, index)">
                                                    <img :src="item.picUrl">
                                                </div>
                                                <div class="item-name titlefs15 titlefw">{{ item.name }}</div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="recommend " style="width: 1200px;margin: 0 auto;">
                    <div class="topTitle">
                        <div class="item-engine-title clear txt-l" style="display: flex;align-items: center;">
                            <div style="width: 100px;margin-right: 20px;">
                                <span class="title-t">
                                    <span class="title-icon bg-theme" style="background: #3D82F2;"></span>
                                    <span>
                                        <span style="color: #000000;">阅读推荐</span></span>
                                </span>
                            </div>
                            <div style="display: flex;justify-content: space-between;width: 90%;">
                                <ul style="display: flex;">
                                    <!-- <li class="title">新书推荐</li> -->
                                </ul>
                                <span style="color: #ccc;cursor: pointer;" @click="goMore">更多></span>
                            </div>
                        </div>
                    </div>
                    <!-- 阅读推荐 -->
                    <div class="rightContent fl">
                        <!-- <el-carousel :interval="3000" arrow="always" @change="listChange" direction="vertical" :loop="true"
                            :autoplay="true" indicator-position="none">
                            <el-carousel-item v-for="(list, index) in readDataArr" :key="index">
                                <ul class="rightInfo">
                                    <li v-for="(item, i) in list" :key="i">
                                        <img :src="item.picurl" alt="" @click="goReadTuiJian(item)">
                                        <p @click="goReadTuiJian(item)">{{ item.c200a }}</p>
                                    </li>
                                </ul>
                            </el-carousel-item>
                        </el-carousel> -->
                        <vue-seamless :data="readData" :class-option="defaultOption" class="seamless">
                            <ul class="rightInfo">
                                <li v-for="(item, i) in readData" :key="i">
                                    <img :src="item.picurl" alt="" @click="goReadTuiJian(item)">
                                    <p @click="goReadTuiJian(item)">{{ item.c200a }}</p>
                                </li>
                            </ul>
                        </vue-seamless>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog" v-show="zezao">
            <div class="oneTitle">
                <div class="context">
                    <div class="text" v-show="nextStep == 0">
                        {{ PromptOne }}
                    </div>
                    <div class="text" v-show="nextStep == 1">
                        {{ PromptTwo }}
                    </div>
                    <div class="text" v-show="nextStep == 2">
                        {{ PromptThree }}
                    </div>
                </div>
                <div class="img">
                    <img src="../assets/images/guide.png" alt="">
                    <!-- <span class=""></span> -->
                </div>
                <el-button class="skip" type="primary" size="small" @click="skip">跳过</el-button>
                <el-button class="step" type="success" size="small" @click="step(0)">下一步</el-button>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import calendar from '../components/calendar.vue'
import vueSeamless from 'vue-seamless-scroll'

import getUserIP from '../components/getIp'
import { getUserInfo } from "@/common/utils/localStorage.js";
import CoreCollapseTransition from '../components/CoreCollapseTransition'
import { queryimgebyId, queryWebSet } from "@/api/bannerImg"//小图标 背景图
import { queryflxxbyCondition, queryTreeflxx, queryBookTjbyCondition, queryUserinfobycondition } from "@/api/context1"//一二级分类  添加或更新阅读推荐
import { queryXwxxbyCondition, } from "@/api/news"//新闻
import { queryTipinfobycondition, InsertorUpdateTipInfo } from "@/api/news"//首页流程
import { InserPageView, queryCountbyCondition } from "@/api/dataTotal"//获取访问量
import { queryDianziResourceCondition } from "@/api/dainziBook"//数据库电子资源分类
import MD5 from "../style/MD.js"

export default {
    data() {
        return {
            searchoneLevelData: [],//流程
            PromptOne: "",//流程1
            PromptTwo: "",//流程1
            PromptThree: "",//流程1
            ip: "",//获取本地ip
            link: undefined,//获取地址栏地址
            userName: "",//登录用户真实姓名（阅读学分等入口 cardnum 传参使用）
            addDataTotal: "",//添加访问量
            dataTotal: "",//查询访问量
            pageNum: 1,
            pageSize: 10,
            total: 100,
            value: new Date(),
            tab: 0,
            tabs: 0,
            scroll: null,
            listHeight: [],//获取高度
            leftNavImg: [],//左侧导航
            leftIndex: 10,
            imgShow: false,
            dataInfo: [
                // {
                //     // icon: require('../assets/images/search.png'),
                //     title: "联系我们",
                // },
                {
                    icon: require('../assets/images/search.png'),
                    title: "检索",
                },
                {
                    icon: require('../assets/images/news.png'),
                    title: "新闻与资源",
                },
                {
                    icon: require('../assets/images/activity.png'),
                    title: "服务与活动",
                },
            ],
            kuaijieId: "",//快捷服务
            list: [],
            loading: false,
            active: 0,
            collapse: true,//馆藏书刊显示隐藏
            nextStep: 0,//首页一进来显示步骤
            typename: "",//馆藏书刊一级名字
            zezao: true,
            radio: 0,
            addCagLabel: "",//国内资源单选框
            dateArray: [], //日期
            bannerImg: [],//banner图集合
            videoSource: 'https://netpic.ytzhihui.com/pic/tch/misc/7693227fa9c188fde5dee53eb23fb9a5.mp4',
            autoplay: true, // 设置自动播放
            collectionArr: [],//馆藏一级分类集合
            collectionerjiArr: [],//馆藏二级分类集合
            collectionsanjiArr: [],//馆藏三级分类集合
            guancangArrData: [],//馆藏新闻
            linkName: "",//馆藏书刊一级分类名字
            resourcesErjiName: "",//馆藏书刊简介
            contentShow: false,
            showType: false,//判断显示类型
            shortcutImg: [],//快捷服务小图标
            kuaijieData: [],
            kuaijieArrData: [],
            readerImg: [],//读者服务
            readerImgName: "",
            readerImgId: "",
            scientificImg: [],//科研服务
            ScientificId: "",
            ScientificName: "",
            resourcesArr: [],//馆藏资源分类
            resourcesArrData: [],//馆藏资源新闻链接
            oneDatabaseArr: [],//一级数据库
            twoDatabaseArr: [],//二级数据库
            DatabaseArrData: [],//数据库新闻
            searchInput: "",//馆藏搜索
            DatabaseData: [],//数据库跳转地址
            txt: 0,//数据库索引
            newserjiArr: [],//新闻
            newsName: "",
            tableData: [],//新闻集合
            oneId: "",//新闻一级Id
            twoId: "",//新闻二级Id
            calendarData: [],//活动日历集合
            calendarActiveData: [],//活动日历信息
            nullShow: false,
            currentDate: "",
            startTime: "",
            endTime: "",
            readData: [],//阅读推荐集合
            readDataArr: [],
            indexNav: 0,
            duzheData: [],

            ops: {
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    showDelay: 0, // 在鼠标离开容器后多长时间隐藏滚动条。
                    keepShow: false, // 滚动条是否保持显示。
                    background: '#ccc',// 滚动条背景色。
                    "overflow-x": "hidden"
                }
            },
            videoShow: true,
        };
    },
    computed: {
        defaultOption() {
            return {
                step: 1, // 数值越大速度滚动越快
                limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
            }
        }

    },
    created() {
        let vm = this
        this.$emit('type', vm.calendarActiveData);
        vm.queryCountbyCondition()//获取用户访问量
        vm.startTime = this.getDay(0)
        vm.endTime = this.getDay(0)
        this.$nextTick(() => {
            this.getHeight();
        });
        vm.tab = 0
        console.log(location.href.split('?')[1].split('=')[0]);
        
        if (location.href.split('?')[1].split('=')[0] == "username") {
            this.$nextTick(() => {
                vm.link = location.href.split('?')[1].split('=')[1].substring(0, 11)
                vm.queryUserinfobycondition()
            });
        }
    },
    mounted() {
        let vm = this
        window.addEventListener('scroll', (e) => {
            let top = document.documentElement.scrollTop; // 滚动的高度
            this.listHeight.forEach((item, index) => {
                if ((top + 800) >= item) this.active = index;
            });
        })
        vm.InserPageView()//添加用户访问量
        vm.queryTipinfobycondition()//首页流程
        this.queryLeftShortcut()//左侧导航
        this.queryimgebyId()//banner图
        this.queryKuaijie()//快捷服务小图标
        this.queryflxxbyCondition()//馆藏书刊
        this.ScientificCalendar()//科研服务
        this.readCalendar()//读者服务
        this.queryResources()//馆藏资源
        this.queryOneDatabase()//一级数据库
        this.queryTreeflxx()//新闻模块
        this.queryBookTjbyCondition()//阅读推荐
        this.queryCalendar()//活动日历
        this.queryWebSetVideo()//显示视频还是banner图

    },
    methods: {
        clickVideo() {
            this.autoplay = true;
        },
        //轮播图地址跳转
        imgOpenLink(item) {
            console.log(item);
            if (!item.linkurl) {
            } else {
                window.open(item.linkurl)

            }
        },
        // 查询banner图显示视频还是banner
        queryWebSetVideo() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                setid: 'isvedio',
            }
            queryWebSet(obj).then((res) => {
                if(res.data[0].setvalue == 1) {
                    vm.videoShow = false
                } else {
                    vm.videoShow = true
                }
            });
        },
        //首页流程
        queryTipinfobycondition() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
            }
            queryTipinfobycondition(obj).then((res) => {
                vm.searchoneLevelData = res.data[0].tip
                vm.PromptOne = vm.searchoneLevelData.split('#')[0]
                vm.PromptTwo = vm.searchoneLevelData.split('#')[1]
                vm.PromptThree = vm.searchoneLevelData.split('#')[2]
            });
        },
        //获取访问数量
        queryCountbyCondition() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                user_ip: "127.0.0.1",
                fwtype: 1
            }
            queryCountbyCondition(obj).then((res) => {
                vm.dataTotal = res.data
                if (vm.dataTotal >= 0) {
                    vm.zezao = false
                } else {
                    vm.zezao = true
                }
            });
        },
        //添加网站访问量
        InserPageView() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                page_url: 'index',
                fwtype: 1
            }
            InserPageView(obj).then((res) => {
                vm.addDataTotal = res.data
            });
        },
        VRlink() {
            window.open("https://www.720yun.com/t/cavkt7rbrdb?scene_id=74623624")
        },
        listChange(index) {
            let vm = this
        },
        //点击日历的时间方法
        gotime(date) {
            let vm = this;
            vm.currentDate = date.data;
            vm.startTime = vm.currentDate
            vm.endTime = vm.currentDate
            vm.queryCalendar()
        },
        //点击馆藏书刊内下的国内资源单选框
        changeMax(vId) {
            let vm = this
            let obj = {};
            obj = vm.collectionsanjiArr.find((item) => {
                return item.name === vId;
            })
            vm.addCagLabel = obj.value
        },
        openLink() {
            window.open("http://lib.wtbu.edu.cn/#/detailList?id=267&parentId=276&indexNav=5")
        },
        // 点击右侧的导航
        clickNav(type) {
            let itemList = document.getElementsByClassName('grid-wrap');
            if (type == 0) {
                let index = document.getElementById('index');
                index.scrollIntoView({ behavior: "smooth", block: 'start', inline: "nearest" });
                return;
            }
            itemList[type].scrollIntoView({ behavior: "smooth", block: 'start', inline: "nearest" });
        },
        goTop() {
            let vm = this;
            let type = 0;
            document.documentElement.scrollTop= 0
            // vm.click(type)
        },
        // 获取元素offsetTop
        getHeight() {
            let itemList = document.getElementsByClassName('grid-wrap');
            let elementF = document.getElementsByClassName('content');
            let height = 0;
            for (let i = 0; i < itemList.length; i++) {
                if (i > 0) {
                    height = itemList[i].offsetTop + elementF[0].offsetTop;
                }
                this.listHeight.push(height);
            }
        },
        // 展示左侧导航小图标
        queryLeftShortcut() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                "type": 3,
            }
            queryimgebyId(obj).then((res) => {
                vm.leftNavImg = res.data
            });
        },
        move(item, index) {
            let vm = this;
            vm.leftIndex = index
        },
        leave(item, index) {
            let vm = this;
            vm.leftIndex = 6
        },
        // 馆藏书刊列表折叠
        fold() {
            this.collapse = false
            let aaa = document.getElementsByClassName('down-info')
            aaa.height = '0'
        },
        // 馆藏书刊列表展开
        expand() {
            this.collapse = true
        },
        // 下一步
        step(e) {
            let vm = this
            vm.nextStep++
            if (vm.nextStep == 3) {
                vm.zezao = false
                // this.$router.push({path:"/",query:{a:1}})
            }
        },
        // 跳过
        skip() {
            let vm = this
            vm.zezao = false
        },
        // 查找banner图片信息
        queryimgebyId() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                "type": 1,
            }
            queryimgebyId(obj).then((res) => {
                vm.bannerImg = res.data
            });
        },
        // 查看馆藏一级分类
        queryflxxbyCondition() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                type: 8,
            }
            queryflxxbyCondition(obj).then((res) => {
                if (res.data.list == "") {
                    vm.resourcesErjiName = ""
                } else {
                    vm.collectionArr = res.data.list
                    vm.tab = 0
                    vm.queryerjiCondition(vm.collectionArr[0])
                }
                vm.searchInput = ""
            });
        },
        // 查看馆藏二级分类
        queryerjiCondition(item, index) {
            let vm = this;
            vm.linkName = item.name
            let userInfo = getUserInfo();
            vm.typename = item.name
            var obj = {
                type: 8,
                parentId: item.id,
            }
            queryflxxbyCondition(obj).then((res) => {
                if (res.data.list != "") {
                    vm.collectionerjiArr = res.data.list
                    vm.querysanjiCondition(vm.collectionerjiArr[0])
                    vm.resourcesErjiName = vm.collectionerjiArr[0].content
                    vm.tab = index
                    vm.tabs = 0
                } else {
                    if (res.data.list == "") {
                        vm.tab = index
                        vm.resourcesErjiName = ""
                        vm.collectionerjiArr = []
                        vm.collectionsanjiArr = []
                    }

                }
                vm.searchInput = ""
            });
        },
        // 查看馆藏三级分类
        querysanjiCondition(item, index) {
            let vm = this;
            let userInfo = getUserInfo();
            vm.resourcesErjiName = item.content
            vm.tabs = index
            var obj = {
                type: 8,
                parentId: item.id,
            }
            queryflxxbyCondition(obj).then((res) => {
                vm.collectionsanjiArr = res.data.list
                vm.collectionsanjiArr.map(item => {
                    if (item.showType == 1) {
                        vm.showType = true
                    } else {
                        vm.showType = false
                    }
                })
                vm.searchInput = ""
            });
        },
        // 馆藏新闻
        guancangCondition(id) {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                flid: id,
            }
            queryXwxxbyCondition(obj).then((res) => {
                vm.guancangArrData = res.data.list
                if (vm.guancangArrData[0].linkUrl != "") {
                    window.open(vm.guancangArrData[0].linkUrl)
                } else {
                    this.$router.push({
                        name: "databasedetail",
                        query: { flid: id, flag: true },
                    });
                }
            });
        },
        //馆藏书刊链接跳转查询数据
        searchLink() {
            let vm = this;
            if (vm.linkName == '馆藏书刊') {
                window.open('http://libopac.wtbu.edu.cn:8083//SMJS/tableResultDetail?strText=' + vm.searchInput)
            } if (vm.linkName == '电子期刊') {
                window.open('https://xueshu.baidu.com/ndscholar/browse/search?wd=' + vm.searchInput)
            } if (vm.linkName == '电子图书') {
                window.open('https://ss.zhizhen.com/s?sw=' + vm.searchInput)
            } if (vm.linkName == '综合数据库') {
                window.open('http://wtbu.cwkeji.cn:8080/ermsClient/browse.do?sw=' + vm.searchInput)
            } if (vm.linkName == '百度搜索') {
                window.open('https://xueshu.baidu.com/s?wd=' + vm.searchInput)
            } if (vm.linkName == '工具书检索') {
                window.open('http://gongjushu.cnki.net/RBook/Search/SimpleSearch?key=' + vm.searchInput)
            }
        },
        // 馆藏书刊详情
        goCondition(item) {
            let vm = this;
            let userInfo = getUserInfo();
            vm.guancangCondition(item.id)
        },
        //快捷服务
        queryKuaijie() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                type: 6
            }
            queryTreeflxx(obj).then((res) => {
                if (res.data == "") {

                } else {
                    vm.kuaijieData = res.data
                }
            });
        },
        // 查询用户信息（阅读学分等入口 cardnum 传参需要 userName）
        queryUserinfobycondition() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                userName: vm.link,
                type: 2,
            }
            queryUserinfobycondition(obj).then((res) => {
                this.$nextTick(() => {
                    this.userName = res.data[0].realName
                });
            });
        },
        // 快捷服务新闻
        KuaijieCondition(id) {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                flid: id,
                cardnum: this.userName,//2026阅读学分等入口：cardnum 取登录用户真实姓名
            }
            queryXwxxbyCondition(obj).then((res) => {
                vm.kuaijieArrData = res.data.list
                if (vm.kuaijieArrData[0].titile == "图书荐购") {
                    window.location.assign("https://lib.wtbu.edu.cn/whgs/api/caslogin?logintype=3")
                    
                } else {
                    if (vm.kuaijieArrData[0].titile == "绿色低碳") {
                        window.open(vm.kuaijieArrData[0].linkUrl)
                    } else{
                        if (vm.link == undefined) {
                            let sign = ""
                            // console.log("id=" + vm.link + "&schoolname=whgsxytsg" + "&key=sxyuntiangou123");
                            // sign = MD5("id=" + vm.link + "&schoolname=whgsxytsg" + "&key=sxyuntiangou123")
                            // window.open('http://rmd.haishengbook.com/#/Xindex?id=' + vm.link + '&schoolname=whgsxytsg&key=sxyuntiangou123&sign=' + sign)
                            // window.open('http://192.168.7.96:8082/#/Xindex?id=' + vm.link + '&schoolname=whgsxytsg&key=sxyuntiangou123&sign=' + sign)
                            window.location.assign("https://lib.wtbu.edu.cn/whgs/api/caslogin?logintype=2")
                        } else {
    
                            if (vm.kuaijieArrData != "") {
                                if (vm.kuaijieArrData[0].linkUrl != "") {
                                    window.open(vm.kuaijieArrData[0].linkUrl)
                                    
                                } else {
                                    this.$router.push({
                                        name: "detail",
                                        query: { flid: id, flag: true },
                                    });
                                }
        
                            } else {
                            }
                        }
                    }
                }                    
                
            });
        },
        // 快捷服务详情
        goShortcut(item) {
            let vm = this
            vm.KuaijieCondition(item.id)
        },
        // 展示读者服务标题
        readCalendar() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                type: 10,
                parentId: 178
            }
            queryflxxbyCondition(obj).then((res) => {
                if (res.data == "") {

                } else {
                    // vm.readerImgName = res.data[3].name
                    // vm.readerImgId = res.data[3].id
                    vm.readerImg = res.data.list
                    // vm.queryReader(vm.readerImgId)
                }
            });
        },
        // 去读者服务详情页
        goDatialList(item, index) {
            let vm = this
            console.log(item);
            // if(item.linkUrl == null) {
            //     this.$router.push({
            //         name: "detailList",
            //         query: { id: vm.readerImgId, parentId: item.id, indexNav: index },
            //     });
            // } else {
            //     window.open(item.linkUrl)
            // }
            vm.duzheCondition(item.id,index)
        },
        // 快捷服务新闻
        duzheCondition(id, index) {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                flid: id,
            }
            queryXwxxbyCondition(obj).then((res) => {
                vm.duzheData = res.data.list
                console.log(vm.duzheData);
                if (vm.duzheData != "") {
                    if (vm.duzheData[0].linkUrl != "") {
                        window.open(vm.duzheData[0].linkUrl)
                    } else {
                            this.$router.push({
                                name: "detailList",
                                query: { id: 178, parentId: id, indexNav: index },
                            });
                    }

                } else {
                }
            });
        },
        // 展示科研服务标题
        ScientificCalendar() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                type: 10,
                parentId:179
            }
            queryflxxbyCondition(obj).then((res) => {
                if (res.data == "") {

                } else {
                    // vm.ScientificName = res.data[4].name
                    // vm.ScientificId = res.data[4].id
                    // vm.scientificImg = res.data[4].childDisease
                    vm.scientificImg = res.data.list
                    // vm.queryScientific(vm.ScientificId)
                }
            });
        },
        //科研服务详情
        goScientific(item, index) {
            let vm = this
            this.$router.push({
                name: "detailList",
                query: { id: 179, parentId: item.id, indexNav: index },
            });
        },
        // 查看馆藏资源分类
        queryResources() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                type: 9,
            }
            queryflxxbyCondition(obj).then((res) => {
                vm.resourcesArr = res.data.list
            });
        },
        // 馆藏资源链接新闻
        ResourcesCondition(id) {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                flid: id,
            }
            queryXwxxbyCondition(obj).then((res) => {
                vm.resourcesArrData = res.data.list
                if (vm.resourcesArrData[0].linkUrl != "") {
                    window.open(vm.resourcesArrData[0].linkUrl)
                } else {
                    this.$router.push({
                        name: "detail",
                        query: { flid: id, flag: true },
                    });
                }
            });
        },
        //馆藏资源更多
        clickGczyMore() {
            let vm = this
            this.$router.push({
                name: "detailList",
                query: { type: 9, indexNav: 0 },
            });
        },
        // 馆藏资源链接与新闻
        goLink(item) {
            let vm = this;
            let userInfo = getUserInfo();
            console.log(item);
            if (item.name == "新书精品") {
                var obj = {
                    flType: 10,
                    flid: 376,
                    shstate: 2
                }
                queryXwxxbyCondition(obj).then((res) => {
                    this.$router.push({
                        name: "detail",
                        query: { id: res.data.list[0].id, },
                    });
                })
            } else {
                vm.ResourcesCondition(item.id)
            }
        },
        //查看数据库
        queryOneDatabase(item, index) {
            let vm = this;
            let userInfo = getUserInfo();
            vm.txt = index
            var obj = {
                type: 7,
                qiyong: 1,
            }
            queryflxxbyCondition(obj).then((res) => {
                if (res.data.list == "") {

                } else {
                    vm.oneDatabaseArr = res.data.list
                    vm.queryTwoDatabase(vm.oneDatabaseArr[0])
                    vm.txt = 0
                }
            });
        },
        //查看二级数据库
        queryTwoDatabase(item, index) {
            let vm = this;
            vm.txt = index
            let userInfo = getUserInfo();
            var obj = {
                type: 7,
                parentId: item.id,
                pageNum: vm.pageNum,
                qiyong: 1,
                pageSize: 24,
                // sjkflid: item.id,
            }
            queryflxxbyCondition(obj).then((res) => {
                vm.twoDatabaseArr = res.data.list
            });
        },
        // 数据库新闻
        DatabaseCondition(id) {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                flid: id,
            }
            queryXwxxbyCondition(obj).then((res) => {
                vm.DatabaseArrData = res.data.list
                if (res.data.total == 0) {
                    this.$message({
                        "message": '暂无数据',
                        "type": "error"
                    })
                } else {
                    window.open(vm.DatabaseArrData[0].linkUrl)
                }
            });
        },
        //数据库更多
        clickShujukuMore() {
            let vm = this
            this.$router.push({
                name: "detailList",
                query: { type: 7 , indexNav: 0 },
            });
        },
        //数据库详情
        goDatabase(item) {
            let vm = this;
            let userInfo = getUserInfo();
            vm.DatabaseCondition(item.id)
        },
        // 新闻模块
        queryTreeflxx() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                type: 10
            }
            queryTreeflxx(obj).then((res) => {
                if (res.data == "") {

                } else {
                    res.data.map(item => {
                        if (item.name == "新闻") {
                            
                            vm.newserjiArr = item.childDisease[0].id
                            vm.newsName = item.childDisease[0].name
                            vm.queryXwxxbyCondition(vm.newserjiArr)
                            vm.oneId = item.id
                            vm.twoId = item.childDisease[0].id
                        }
                    })
                }
            });
        },
        // 查找新闻通知
        queryXwxxbyCondition(id) {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                flid: id,
                shstate: 2
            }
            queryXwxxbyCondition(obj).then((res) => {
                vm.tableData = res.data.list.splice(0, 5)
            });
        },
        //新闻更多
        goMoreList() {
            let vm = this
            console.log(vm.twoId);
            this.$router.push({
                name: "detailList",
                query: { id: vm.oneId, parentId: vm.twoId, indexNav: 0 },
            });
        },
        // 查找活动日历
        queryCalendar() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                flType: 11,
                startTime: this.getYear(0) + '-' + vm.startTime,
                endTime: this.getYear(0) + '-' + vm.endTime
            }
            queryXwxxbyCondition(obj).then((res) => {
                if (res.code == 200) {
                    vm.calendarActiveData = res.data.list;
                    if (res.data.total == 0) {
                        vm.nullShow = true
                    } else {
                        vm.nullShow = false
                    }
                }
            });
        },
        // 活动日历更多
        goHuoDong() {
            let vm = this
            this.$router.push({
                name: "detailList",
                query: { indexNav: 'true' },
            });
        },
        // 去活动日历详情页
        goDatial(item) {
            let vm = this
            this.$router.push({
                name: "detail",
                query: { id: item.id, flag: false },
            });
        },

        // 阅读推荐
        queryBookTjbyCondition() {
            let vm = this;
            let userInfo = getUserInfo();
            var obj = {
                pageSize: 10,
                pageNum: 1
            }
            queryBookTjbyCondition(obj).then((res) => {
                if (res.code == 200) {
                    vm.readData = res.data.list
                    // for (let i = 0; i < vm.readData.length; i += 5) {
                    //     vm.readDataArr.push(vm.readData.slice(i, i + 5))
                    // }
                }
            });
        },
        goReadTuiJian(item) {
            let vm = this
            this.$router.push({
                name: "readTuiJian",
                query: { id: item.id },
            });
        },
        //阅读推荐列表页
        goMore() {
            let vm = this
            this.$router.push({
                name: "moreDetail",
            });
        },
        // 获取一周时间
        getDay(day) {
            var today = new Date();
            var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds); //注意，这⾏是关键代码
            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            return tMonth + "-" + tDate;
        },
        getYear(day) {
            var today = new Date();
            var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds); //注意，这⾏是关键代码
            var tYear = today.getFullYear();
            return tYear
        },
        doHandleMonth(month) {
            var m = month;
            if (month.toString().length == 1) {
                m = "0" + month;
            }
            return m;
        },

    },
    components: {
        Header,
        Footer,
        CoreCollapseTransition,
        calendar,
        vueSeamless
    },
}
</script>

<style lang="scss" scoped>

.bgTheme {
    background-color: rgb(176, 37, 42);
    color: rgb(255, 255, 255) !important;
}
.bacColor {
    background-color: rgb(2,70,69);
    box-sizing: border-box;
    color: #Fff;
    display: inline-block;
    width: 60px;
    line-height: 10px;
    height: 30px;
    border-radius: 50px;
    text-align: center;
    margin: 12px 10px 0 10px;
    font-size: 14px
}
.bacColor2 {
    background-color: rgb(224, 175, 40);
    box-sizing: border-box;
    color: #Fff;
    display: inline-block;
    width: 60px;
    line-height: 10px;
    height: 30px;
    border-radius: 50px;
    text-align: center;
    margin: 12px 10px 0 10px;
    font-size: 14px
}
.bacColor3 {
    background-color: rgb(194, 50, 170);
    box-sizing: border-box;
    color: #Fff;
    display: inline-block;
    width: 60px;
    line-height: 10px;
    height: 30px;
    border-radius: 50px;
    text-align: center;
    margin: 12px 10px 0 10px;
    font-size: 14px
}

video {
    width: 100%;
    
    object-fit: unset;
}

video::-webkit-media-controls-fullscreen-button {
    display: none;
}

video::-webkit-media-controls-play-button {
    display: none;
}

video::-webkit-media-controls-timeline {
    display: none;
}

video::-webkit-media-controls-current-time-display {
    display: none;
}

video::-webkit-media-controls-time-remaining-display {
    display: none;
}

video::-webkit-media-controls-mute-button {
    display: none;
}

video::-webkit-media-controls-toggle-closed-captions-button {
    display: none;
}

video::-webkit-media-controls-enclosure {
    display: none;
}

video::-webkit-media-controls-volume-slider {
    display: none;
}

.currents {
    background-color: rgb(0, 0, 0) !important;
    color: rgb(255, 255, 255) !important;
}

#firstSection  {
    position: relative;
}

#firstSection .grid-wrap {
    z-index: 2;
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translate(-50%);
}
#banner {
    position: relative;
}

.grid-wrap {
    position: relative;
    margin: 0 auto;
    width: 1204px;

}

.grid-stack {
    position: relative;
    border: 2px dotted transparent;
}

.grid-wrap {
    overflow: hidden;
}

.bacList {
    // background: url('../assets/images/bacList.png') no-repeat;
    background-size: 100% 100% !important;
}

.eng-search-style11 .el-icon-bottom {
    position: absolute;
    right: 0;
    padding-right: 24px;
    line-height: 56px;
    font-size: 12px;
    // color: #999999;
    cursor: pointer;
    font-size: 20px;
}

::v-deep .el-carousel .el-carousel__arrow--right {
    top: 72%;
    right: 5%;
    font-size: 18px;
    // background-color: red;
    border: 2px solid rgb(176, 37, 42) !important;
    background-color: rgb(176, 37, 42) !important;
}

::v-deep .el-carousel .el-carousel__arrow--left {
    position: absolute;
    top: 72%;
    left: 90%;
    font-size: 18px;
    // background-color: red;
    border: 2px solid rgb(176, 37, 42) !important;
    background-color: rgb(176, 37, 42) !important;
}

.radio-list a {
    color: inherit;
    text-decoration: none;
    display: inline-block;
    font-size: 15px;
    color: #ffffff;
    margin-right: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 5px;
}

#quickEntry {
    position: fixed;
    top: 50%;
    left: 0;
    width: 130px;
    z-index: 221;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}

#anchorsNav {
    position: fixed;
    right: 30px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 100;
}

.content .aid-group-wrap {
    // position: relative;
    z-index: 101;
}

.content .aid-groups {
    position: relative;
    width: 1204px;
    margin: 0 auto;
    z-index: 2;
}

.searchTime {
    display: flex;
    width: 99%;

    .leftButton {
        height: 30px;
        width: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #ccc;
        background-color: #fff;
        cursor: pointer;
    }

    ul {
        float: left;
        margin-top: 1px;

        li {
            width: 60px;
            height: 30px;
            line-height: 30px;
            margin: 0 10px;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.1);
            float: left;
            cursor: pointer;
            font-size: 14px;
        }
    }

    .rightButton {
        height: 30px;
        width: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px solid #ccc;
        background-color: #fff;
        cursor: pointer;
    }
}

.text-list-wrap-img {
    .imgUrl {
        width: 100%;
        margin-top: 20px;
        overflow-y: hidden;
        overflow-x: hidden;
        height: 200px;

        div {
            display: inline-block;
            position: relative;

            img {
                width: 200px;
                height: 210px;
                position: relative;
                cursor: pointer;
            }

            p {
                position: absolute;
                bottom: 5px;
                height: 40px;
                line-height: 40px;
                width: 200px;
                background-color: rgba(0, 0, 0, 0.2);
                text-align: center;
                color: #fff;
                cursor: pointer;
            }

            // img:hover p{
            //     display: inline-block;
            //     color: red;
            // }
        }
    }
}

.content .aid-groups .grid-wrap:not(:last-child) {
    margin-bottom: 12px;

}

#index .grid-stack .grid-stack-item-content {
    // overflow-y: hidden;
    // margin-top: 20px;
    // overflow-x: hidden;
    height: 100%;

    .items {
        display: inline-block;
        margin: 0 40px 10px 0;
        /* width: 60px; */
        width: calc(100% / 12);
        margin-right: 0;
        color: inherit;
        vertical-align: top;
        overflow: hidden;

        .icon-box {
            width: 60px;
            height: 60px;
            overflow: hidden;
            border-radius: 8px;
            margin: 0 auto;
        }
    }

    .item {
        display: inline-block;
        margin: 0 40px 10px 0;
        /* width: 60px; */
        width: calc(100% / 8);
        margin-right: 0;
        color: inherit;
        vertical-align: top;
        overflow: hidden;
    }
}

#text-style-37-75a06642-6559-443b-81b2-89487a14aed3 {
    // background: url('../assets/images/resources2.png') no-repeat;
    background-color: rgba(255, 0, 25, 0.2);
    background-size: 100% 100%;
}

#text-style-29-2a4b8bd6-e0c6-4fa7-8960-e7f34a56a3ee {
    // background: url('../assets/images/resources1.png') no-repeat;
    background-color: rgba(0, 0, 0, 0.91);
    background-size: 100% 100%;
    color: #fff;
    // height: 625px;
    height: 100%;
    min-height: 200px;
    box-sizing: border-box;
}

.item-engine-title {
    min-height: 46px;
    line-height: 22px;
    padding: 0 17px 0 0;
    margin-bottom: 20px;
}

#anchorsNav ul.common-right-nav2>li {
    margin-bottom: 2px;
    width: 50px;
    height: 50px;
    border-radius: 8px !important;
    background: rgba(0, 0, 0, .4);
    text-align: center;
    -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, .2);
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, .2);
    border: 2px solid rgba(255, 255, 255, .5);
    padding: 0;
}

#anchorsNav ul.common-right-nav2>li a {
    position: relative;
    display: block !important;
    width: 100% !important;
    text-align: center;
    font-size: 16px;
    height: 100%;
    border-radius: 8px;
    color: #000;
}

#anchorsNav ul.common-right-nav2>li img {
    width: 40px;
    height: 40px;
    margin: 3px 0 0;
}

#anchorsNav ul.common-right-nav2>li a .anchors-name {
    position: absolute;
    display: none;
    right: 54px;
    top: 10px;
    min-width: 104px;
    height: 30px;
    line-height: 30px;
    padding: 0 6px;
    white-space: nowrap;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: rgba(255, 255, 255, .5);
    border-radius: 15px;
    border: 1px solid rgba(0, 0, 0, .4)
}

#anchorsNav ul.common-right-nav2>li a:hover .anchors-name {
    display: inline-block;
}

#bgs {
    position: absolute;
    width: 100%;
    z-index: 0;
    top: 0;
    overflow: hidden;
}

#bgs .bg-box {
    height: 100%;
}

#ccc {
    position: relative;
}

.active {
    background-color: red;
}

.search-box {
    .el-input {
        border: 0;

        ::v-deep .el-input .el-input__inner {
            border: 0;
        }
    }
}

.dialog {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(0, 0, 0, .9);
    z-index: 1000;
    top: 0;
    left: 0;
    background: url('../assets/images/banner2.jpg') no-repeat;

    .oneTitle {
        width: 50%;
        height: 600px;
        // margin-top: 10%;
        // background-color: antiquewhite;
        margin: 10% auto;

        .context {
            width: 400px;
            height: 300px;
            border-radius: 50%;
            background-color: rgba(98, 98, 98, 0.5);
            position: relative;

            .text {
                // position: fixed;
                // top: 40vh;
                // left: 80vh;
                padding-top: 75px;
                padding-left: 50px;
                color: aliceblue;
                width: 80%;
                font-size: 18px;
            }

        }

        .img img {
            position: absolute;
            height: 60px;
            width: 60px;
            margin-top: 1%;
            margin-left: 15%;
            // transform: rotate(30deg);
            // width: 20%;
        }

        .skip {
            // position: fixed;
            margin-top: 10%;
            margin-left: 30%;
        }

        .step {
            // position: fixed;
            top: 15%;
            right: 50%;
        }
    }
}

::v-deep .el-radio .el-radio__label {
    color: #fff;
    // margin-right: 10px;
}

//阅读推荐
.recommend {
    height: 350px;
    background-color: #fff;

    .title {
        color: rgb(26, 109, 53);
        border-bottom: 2px solid rgb(26, 109, 53);
    }

    .topTitle .title-t {
        height: 40px;

        // display: flex;
        // align-items: center;
        span {
            font-size: 18px;
            color: rgb(26, 109, 53);
            // margin-right: 50px;
            font-weight: 600;
            margin-top: -5px;
        }

        ul li {
            margin: 0 20px;
            line-height: 25px;
            font-size: 16px;
        }
    }

    .leftContent {
        width: 49%;
        margin-top: 30px;
        display: flex;

        img {
            height: 400px;
        }

        .info {
            margin-left: 20px;
            color: #ccc;

            p {
                line-height: 37px;

                span {
                    display: inline-block;
                }

                .el-icon-arrow-left {
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 20px;
                    background-color: #ccc;
                    color: #000;
                }

                .el-icon-arrow-right {
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    font-size: 20px;
                    background-color: #ccc;
                    color: #000;
                }
            }
        }
    }

    ::v-deep  .seamless>div {
        width: 100%;
    }

    .rightContent {
        width: 100%;
        margin-top: 30px;
        height: 240px;
        overflow: hidden;

        .seamless {
            width: 100%;
            overflow: hidden;
            height: 100%;
        }

        .rightInfo {
            height: 100%;
            // width: 1200px;
            display: flex;

            li {
                width: 150px;
                float: left;
                text-align: center;

                img {
                    width: 130px;
                    height: 165px;
                    cursor: pointer;
                }

                p {
                    // width: 50%;
                    // text-align: center;
                    line-height: 40px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-left: 30px;
                    margin-bottom: 20px;
                    cursor: pointer;
                }
            }
        }
    }
}

.custom-text-style3 {
    .goTop {
        display: inline-block;
        width: 80px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: rgb(176, 37, 42) !important;
        margin: 0;
        padding-left: 10px;
        cursor: pointer;
    }
}

.list-item {
    .box {
        i {
            display: inline-block;
            width: 10px;
            position: absolute;
            left: 5px;
            line-height: 40px;
        }
    }

    span {
        margin-left: 20px;
    }
}

.grid-stack-item-base-container {
    // background: url('../assets/images/banner2.jpg');
    // background-color: rgba(44, 47, 63,0.8);
    background-size: 100% 100%;
}

::v-deep  .el-carousel--vertical {
    height: 240px;
}

::v-deep  .el-carousel__container {
    height: 240px;
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue